exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-457b5ce4] {\n  background-color: #fff;\n  padding: 20px;\n  min-height: 70vh;\n}\n", ""]);

// exports
